// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__mPTpB","search":"Settings_search__3NCOG","filter":"Settings_filter__urVIy"};